<cac-dialog-layout title="تاریخچه دارایی" [hideControls]="true">
  <cac-table [options]="table"></cac-table>
</cac-dialog-layout>
